module.exports = {"userInfoText":"User Info","logoutText":"Logout","userLang":"English","language":"Language","group":"Group","languageItem":{"en-US":"English","zh-TW":"繁體中文","zh-CN":"簡体中文"},"en-US":"English","zh-TW":"繁體中文","zh-CN":"簡体中文","themeText":"Theme","Mobile":{"userLang":"En"},"selectPlaceholder":"Select","selectTimePlaceholder":"Select Time","selectNotFoundText":"Data Not Found","tableNoDataText":"No Data","tableNoFilteredDataText":"No Filtered Data"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/main.json
// module id = TEtM
// module chunks = 3